<template>
  <div>
    <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5 no-print"> </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <slide-x-left-transition
            :duration="200"
            mode="out-in"
            origin="center top"
          >
            <form @submit.prevent>
              <h2>{{formatarData(data)}} - Solicitação Nº {{numero}}</h2>

              <template v-if="loading">
                <div class="m-2">
                  <skeleton altura="20px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
              </template>

              <card shadow type="white" class="mb-3 no-print" style="overflow: scroll;" v-show="user.tipo == 'lab'">
                <div class="row statusTimeline justify-content-center" style="min-width: 900px; width: 100%;">

                  <div class="item d-flex flex-column" :class="{ativo: status == 0, passado: status > 0}">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="far fa-clock fa-2x mb-2"></span>
                      Aguardando aprovação
                    </div>
                    <div class="row d-center" v-if="status == 0">
                      <base-button @click="mudarStatus(1)" type="info" size="sm" class="mt-3 align-self-center">Aprovar</base-button>
                      <base-button @click="mudarStatus(7)" type="danger" size="sm" class="mt-3 align-self-center">Recusar</base-button>
                    </div>
                  </div>

                  <div class="item d-flex flex-column recusado" :class="{ativo: status == 7}" v-if="status == 7">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="far fa-times-circle fa-2x mb-2"></span>
                      Recusado
                    </div>
                  </div>

                  <div class="item d-flex flex-column" :class="{ativo: status == 1, passado: status > 1 && status != 7}">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="fas fa-check fa-2x mb-2"></span>
                      Aprovado
                    </div>
                    <div class="row d-center" v-if="status == 1">
                      <base-button @click="mudarStatus(2)" type="info" size="sm" class="mt-3 align-self-center">Produzindo</base-button>
                      <base-button @click="mudarStatus(6)" type="danger" size="sm" class="mt-3 align-self-center">Cancelar</base-button>
                    </div>
                  </div>

                  <div class="item d-flex flex-column" :class="{ativo: status == 2, passado: status > 2 && status != 7}">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="fas fa-hourglass-half fa-2x mb-2"></span>
                      Em produção
                    </div>
                    <div class="row d-center" v-if="status == 2">
                      <base-button @click="mudarStatus(3)" type="info" size="sm" class="mt-3 align-self-center">Pronto</base-button>
                      <base-button @click="mudarStatus(6)" type="danger" size="sm" class="mt-3 align-self-center">Cancelar</base-button>
                    </div>
                  </div>

                  <div class="item d-flex flex-column" :class="{ativo: status == 3, passado: status > 3 && status != 7}">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="fas fa-box fa-2x mb-2"></span>
                      Pronto para retirar
                    </div>
                    <div class="row d-center" v-if="status == 3">
                      <base-button @click="mudarStatus(5)" type="info" size="sm" class="mt-3 align-self-center">Entregue</base-button>
                    </div>
                  </div>

                  <div class="item d-flex flex-column" :class="{ativo: status == 5, passado: status > 5 && status != 7}">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="far fa-check-circle fa-2x mb-2"></span>
                      Entregue
                    </div>
                  </div>

                  <div class="item d-flex flex-column cancelado" :class="{ativo: status == 6}" v-if="status == 6">
                    <div class="d-flex align-items-center flex-column px-4">
                      <span class="far fa-times-circle fa-2x mb-2"></span>
                      Cancelado
                    </div>
                  </div>
                </div>
              </card>

              <card class="protetic">
                <div class="row">
                  <div class="col-12 col-lg-8">
                        
                   
                    <div class="form-group has-label"> 
                        <label class="form-control-label"> 
                          Protético Relacionado
                        </label>

                        <multiselect
                          v-model="protetico"
                          track-by="id"
                          label="nomeCompleto"
                          :options="proteticos"
                          placeholder="Selecione um Protético"
                          :multiple="false"
                          selectLabel="Selecionar"
                          selectedLabel="✔"
                          deselectLabel="Limpar"
                          >
                          <span slot="noResult">Todos os Protéticos</span>
                      </multiselect>
                     </div>
                     </div>
               </div>
              </card>
             
              <card shadow type="secondary">
                <div class="row">
                  <div class="col-8">
                    <h6 class="heading-small text-muted mb-1">
                      {{ laboratorio.nomeFantasia }}
                    </h6>
                    <h6 class="heading-small text-muted mb-4">
                      Responsável Técnico: {{ laboratorio.nomeResponsavel }} - CRO
                      {{ laboratorio.croResponsavel }}
                    </h6>
                  </div>
                </div>
                <flow-form :campos="campos">
                  <div slot="dente">
                    <div class="selecaoDente row justify-content-center">
                      <template v-for="(area, ai) in campos.dente.opcoesDentes">
                        <div
                          class="area row m-2"
                          :class="{ baixo: ai > 1 }"
                          :key="'area_dente_' + ai"
                        >
                          <span
                            class="dente d-center clickable"
                            :class="[{
                              selecionado: denteSelecionado(dente),
                            },denteAgrupado(dente)]"
                            v-for="dente in area"
                            :key="'dente_' + dente"
                            >{{ dente }}</span
                          >
                        </div>
                        <div
                          class="break col-12"
                          :key="'justa_break' + ai"
                          v-if="ai == 1"
                        ></div>
                      </template>
                    </div>
                    <div class="dentesSelecionados mt-4">
                      <template v-for="dente in campos.dente.value">
                          <template v-if="Array.isArray(dente)">
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + idGrupo(dente)"
                            >
                              <div class="nmDente py-3 row align-items-center justify-content-center mx-0">
                                <span title="Estes dentes estão agrupados" class="corGrupo" :class="denteAgrupado(dente[0].numero)"></span>
                                {{nomeGrupo(dente)}}
                              </div>
                              <flow-form :campos="dente[0]" />
                            </div>
                          </template>
                          <template v-else>
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + dente.numero"
                            >
                              <div class="nmDente py-3">Dente {{ dente.numero }}</div>
                              <flow-form :campos="dente" />
                            </div>
                          </template>
                        </template>
                    </div>
                  </div>
                </flow-form>
               
                 <div class="files" v-if="arquivos">
                    <label class="form-control-label">Arquivos - Anexados pelo Dentista</label> 
                    <ul>
                      <li v-for="(arquivo, key) in arquivos" :key="key">
                          <a :href="storage_url + '/storage/' + arquivo.file" title="Abrir Arquivo" target="_blank">{{arquivo.name}}</a>
                      </li>
                    </ul>
                </div>

                 <div class="files" v-if="arquivos2">
                    <label class="form-control-label">Arquivos - Anexados pelo Laboratório</label> 
                    <ul>
                      <li v-for="(arquivo, key) in arquivos2" :key="key">
                          <a :href="storage_url + '/storage/' + arquivo.file" title="Abrir Arquivo" target="_blank">{{arquivo.name}}</a>
                      </li>
                    </ul>
                </div>

                <div class="files" v-if="arquivos3">
                  <label class="form-control-label">Arquivos - Anexados pelo Protético</label> 
                  <ul>
                    <li v-for="(arquivo, key) in arquivos3" :key="key">
                        <a :href="storage_url + '/storage/' + arquivo.file" title="Abrir Arquivo" target="_blank">{{arquivo.name}}</a>
                    </li>
                  </ul>
              </div>

              <div class="valuer" v-show="1 == 2">
                  <div class="row">
                      <div class="col-12 col-lg-4">
                          <base-input alternative=""
                              label="Valor desta Ordem de Serviço"
                              input-classes="form-control-alternative"
                              v-model="valor_solicitacao"
                          />
                      </div>
                </div>
              </div>

              <div class="valuer" v-show="user.tipo == 'lab'">
                  <div class="row">
                      <div class="col-12 col-lg-4">
                          <base-input alternative=""
                              label="Descritivos Extras"
                              input-classes="form-control-alternative"
                              v-model="extra_descritivo"
                          />
                      </div>

                       <div class="col-12 col-lg-4">
                          <base-input alternative=""
                              label="Valores Extras"
                              input-classes="form-control-alternative"
                              v-model="extra_valor"
                          />
                      </div>
                </div>
              </div>

              <div class="uploader">
                    <label v-show="user.tipo == 'lab' || user.tipo == 'pro'">
                        <i class="ni ni-cloud-upload-96" />
                        <span>Selecionar Arquivos</span>
                        <input type="file" @change="processFiles" multiple />
                    </label>
                    <ul class="uploader-list">
                        <li v-for="(file, k) in filesArray" :key="k">{{file.name}}</li>
                    </ul>
              </div>
               
                <div slot="footer" class="caseSalvar d-center flex p-2 no-print" :class="{visivel: botoesVisiveis}" v-show="user.tipo == 'pro' || user.tipo == 'lab'">
                  <base-button type="default" @click="salvar()">Salvar as alterações</base-button>
                  <base-button type="warning" @click="imprimir()">Imprimir Cupom</base-button>
                </div>

                <template v-if="loading">
                  <div class="m-2">
                    <skeleton altura="20px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                  </div>
                </template>
              </card>
            </form>
          </slide-x-left-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlowForm from "@/components/cflow/FlowForm";
import verSolicitacaoLab from "@/forms/verSolicitacaoLab"
import helpers from "@/cflow/helpers";
import ordens from "@/cflow/ordens.js";
import config from 'config';
import { SlideXLeftTransition, SlideXRightTransition } from "vue2-transitions";
import Multiselect from "vue-multiselect";
import storage from 'storage';

var solicitarOrdem = {
  components: {
    FlowForm,
    SlideXLeftTransition,
    SlideXRightTransition,
    Multiselect
  },
  computed: {
  },
  methods: {
    imprimir: function() {
      ordens.imprimir(this.$route.params.id, false).then( res => {
        var width = 400;
        var height = 800;
        var left = (screen.width / 2) - (width / 2);
        var top = (screen.height / 2) - (height / 2);
        
        var winBox = window.open('', 'CenteredWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
        winBox.document.write(res);
        winBox.document.close();
      } )

    },
    processFiles: function(event) {
      var files = event?.target?.files;
 
      if(files && files.length > 0) {
        this.filesArray = files;
      }
 
    },
    mudarStatus: function(status) {
      this.loading = true;
      ordens.mudarStatus(this.$route.params.id,status).then( res => {
          if(res){
            this.status = status;
          }
          this.loading = false;
      } )
    },
    salvar() {
      this.loading = true;
      //var previsaoEntrega = this.campos.previsaoEntrega.value;
      //var tecnico = this.campos.tecnico.value;

    

      ordens.atualizar({
              protetico: this.protetico
              //tecnico: tecnico
            },this.$route.params.id)
            .then(() => {

              ordens
              .upload(this.filesArray)
                  .then((files_path) => {
                    var files = [];
                    
                    if(files_path.data && files_path.data.length > 0) {
                      files = files_path.data;
                    }

                    var arquivos2 = null;
                    var arquivos3 = null;
                    if(this.user.tipo == 'lab') arquivos2 = files;
                    if(this.user.tipo == 'pro') arquivos3 = files;

                    ordens
                  .atualizar({
                      arquivos2: arquivos2,
                      arquivos3: arquivos3,
                      protetico: this.protetico,
                      valor_solicitacao: this.valor_solicitacao,
                      extra_descritivo: this.extra_descritivo,
                      extra_valor: this.extra_valor
                    },this.$route.params.id)
                    .then((res) => {
                        this.arquivos = JSON.parse(res.arquivos);
                        if(arquivos2) {
                          this.arquivos2 = res.arquivos2;
                        }
                        if(arquivos3) {
                          this.arquivos3 = res.arquivos3;
                        }
                        this.filesArray = [];
                      this.$notify({
                        group: 'geral',
                        title: 'Alteração salva',
                        text: 'Os dados foram atualizados com sucesso',
                        duration: 3000
                      });
                      this.loading = false;
                    
                    })
                  })
                })
    },
    nomeGrupo(grupo) {
      if(!grupo) return ''
      let label = 'Dente';
      if(grupo.length > 1) label + 's';
      let nome = grupo.map(item => { return item.numero })
      let last = nome.length > 1 ? nome.pop() : ''
      return label + ' ' + nome.join(', ') + (last ? ' e ' + last : '');
    },
    idGrupo(grupo) {
      if(!grupo) return ''
      let id = grupo.map(item => { return item.numero })
      return id.join('-')
    },
    denteSelecionado(dente) {
      // Verifica se um dente está selecionado
      const fonte = this.agrupando ? this.grupoTMP : this.campos.dente.value
      return fonte.map(item => { return item.numero }).includes(dente)
    },
    denteAgrupado(dente) {
      // Verifica se um dente é agrupado e dá pra ele a classe com seu número do grupo.
      var num = 0
      var minhaClasse = null
      this.campos.dente.value.some(d => {
        if(Array.isArray(d)){
          // Se for um array de dentes
          d.forEach(sd => {
            // Verificar cada filho
            if(sd.numero === dente) {
              minhaClasse = 'selecionado borda-'+ (num % 5) // o número, num intervalo de 0 a 5, 6 = 0, 7 = 1, etc...
              return true
            }
          })
        }
        num++
      })
      return minhaClasse
    }
  },
  mounted: function () {

    this.user = storage.get("user");

    console.log('user', this.user)

    if (this.$route.params.id) {
      const app = this;
      this.loading = true;
      ordens.detalhes(this.$route.params.id).then((res) => {
        this.numero = res.id;
        this.laboratorio = res.laboratorio;
        this.dentista = res.dentista;
        this.data = res.created_at;
        this.arquivos = res.arquivos;
        this.arquivos2 = res.arquivos2;
        this.arquivos3 = res.arquivos3;
        this.proteticos = res.proteticos;
        this.protetico = res.protetico;
        this.valor_solicitacao = res.valor ? res.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) : '';
        this.extra_descritivo = res.extra_descritivo;
        this.extra_valor = res.extra_valor ? res.extra_valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) : '';
        this.storage_url = config[process.env.NODE_ENV].api.endpoint;
        if (this.dentista.id) {
          this.campos.dr.value = this.dentista.nome;
        }
        this.status = res.status
        helpers.preencherCampos(this.campos, res);

        // Esperar só mais um pouquinho e...
        setTimeout(()=>{
          // Ficar de olho se os botões estão visiveis na tela
          const observer = new IntersectionObserver(function(entries) {
            app.botoesVisiveis = entries[0].isIntersecting
          }, { threshold: [1] });

          if(observer) observer.unobserve(document.querySelector(".caseSalvar"))
          observer.observe(document.querySelector(".caseSalvar"))

          this.loading = false;
        },10)
      });
    }
  },
  data() {
    return {
      loading: false,
      etapa: 0,
      laboratorio: null,
      dentista: {},
      laboratorios: [],
      status: null,
      data: null,
      campos: verSolicitacaoLab,
      filesArray: [],
      proteticos: [],
      protetico: '',
      valor_solicitacao: '',
      user: {},
      extra_descritivo: '',
      extra_valor: ''
    };
  },
};
export default solicitarOrdem;
</script>
<style lang="scss" scoped>
/* Estilos para impressão */

@page {
  size: a4; /* ou 'letter' para papel tamanho carta nos Estados Unidos */
  margin: 1cm; /* margens da página */
}

@media print {
  /* Especifique as tags que você deseja ocultar na impressão */
  html {
    zoom: -50%;
  }

  * {
    background: white;
    box-shadow: none;
  }

  body, h1, h2, h3, h4, h5, h6 {
    font-size: 8px !important;
  }

  hr {
    display: none;
  }

  input[type="checkbox"]:not(:checked) {
    display: none;
  }

  .form-group {
    margin: 0;
    padding: 0;
  }

  .mb-3 {
    margin-bottom: 0 !important;
  }

  .no-print {
    display: none;
  }

  .selecaoDente .selecionado {
    border: 2px solid black;
  }

}
.dente {
  width: 35px;
  height: 45px;
  padding-top: 10px;
  border-radius: 70%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: 0.2s;
}
.baixo .dente {
  border-radius: 70%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: 0;
  padding-bottom: 10px;
}
.dente.selecionado {
  border-color: #000;
  transform: translate3d(0, 10%, 0);
  box-shadow: 0 -5px 3px rgba(0, 0, 0, 0.15);
}
.baixo .dente.selecionado {
  transform: translate3d(0, -10%, 0);
  box-shadow: 0 5px 3px rgba(0, 0, 0, 0.15);
}
.dentesSelecionados .denteSel .nmDente {
  background: #e0e0e0;
  background: -moz-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: -webkit-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: linear-gradient(to bottom, #e0e0e0 0%, #f7f7f7 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0e0e0', endColorstr='#f7f7f7',GradientType=0 );

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  width: auto;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-bottom: 10px;

  .corGrupo{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #000;
    align-self: center;
    margin-right: 5px;
  }
}
@media all and (max-width: 500px) {
  .dente {
    max-width: calc(12.5% - 4px);
  }
  .break {
    height: 50px;
  }
}
.statusTimeline .item {
  position: relative;
}
.statusTimeline .item>div{
  opacity: 0.2;
  transition: 0.2s;
}
.statusTimeline .item::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #CCC;
  z-index: 2;
  transition: 0.2s;
  border: 2px solid transparent;
}
.statusTimeline .item::before {
  content: "";
  width: 100%;
  height: 3px;
  background: #CCC;
  margin: 3px 0 30px 0;
  position: relative;
}
.statusTimeline .item:first-child::before {
  width: 50%;
  left: 50%;
}
.statusTimeline .item:last-child::before {
  width: 50%;
}

.statusTimeline .item.ativo>div {
  opacity: 1;
  color: #00b7ff;
}
.statusTimeline .item.passado>div {
  opacity: 1;
  color: rgb(147, 189, 199);
}
.statusTimeline .item.passado::before {
  background: #00b7ff;
}
.statusTimeline .item.ativo::before {
  background: #00b7ff;
  background: -moz-linear-gradient(left,  #00b7ff 50%, #00b7ff 50%, #cccccc 100%);
  background: -webkit-linear-gradient(left,  #00b7ff 50%,#00b7ff 50%,#cccccc 100%);
  background: linear-gradient(to right,  #00b7ff 50%,#00b7ff 50%,#cccccc 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00b7ff', endColorstr='#cccccc',GradientType=1 );
}
.statusTimeline .item:last-child.ativo::before {
  background: #00b7ff;
}
.statusTimeline .item:first-child.ativo::before {
  background: #00b7ff;
  background: -moz-linear-gradient(left,  #00b7ff 0%, #cccccc 100%);
  background: -webkit-linear-gradient(left,  #00b7ff 0%,#cccccc 100%);
  background: linear-gradient(to right,  #00b7ff 0%,#cccccc 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00b7ff', endColorstr='#cccccc',GradientType=1 );
}

.statusTimeline .item.passado::after {
  background: #00b7ff;
}
.statusTimeline .item.ativo::after {
  background: #fff;
  border-color: rgb(0, 183, 255);
  transform: translate(-50%, 0) scale(1.8)
}

.statusTimeline .item.cancelado>div,.statusTimeline .item.recusado>div{
  color: #f5365c;
}
.statusTimeline .item.cancelado::after,.statusTimeline .item.recusado::after{
  background: #f5365c;
  border: none;
  box-shadow: 0 0px 5px #f5365c;
}
.statusTimeline .item.cancelado::before{
  background: #00b7ff;
  background: -moz-linear-gradient(left,  #00b7ff 0%, #f5365c 100%)!important;
  background: -webkit-linear-gradient(left,  #00b7ff 0%,#f5365c 100%)!important;
  background: linear-gradient(to right,  #00b7ff 0%,#f5365c 100%)!important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00b7ff', endColorstr='#f5365c',GradientType=1 )!important;
}
.statusTimeline .item.recusado::before{
  background: #00b7ff;
  background: -moz-linear-gradient(left,  #00b7ff 0%, #f5365c 50%, #cccccc 51%);
  background: -webkit-linear-gradient(left,  #00b7ff 0%,#f5365c 50%,#cccccc 51%);
  background: linear-gradient(to right,  #00b7ff 0%,#f5365c 50%,#cccccc 51%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00b7ff', endColorstr='#cccccc',GradientType=1 );
}
.caseSalvar>span{
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 700;
  margin-bottom: 5px;
  transition: 0.2s;
}

.borda-0{
  border-color: rgb(59, 137, 211)!important;
}
.borda-1{
  border-color: rgb(116, 189, 113)!important;
}
.borda-2{
  border-color: rgb(169, 133, 204)!important;
}
.borda-3{
  border-color: rgb(213, 214, 125)!important;
}
.borda-4{
  border-color: rgb(228, 133, 133)!important;
}
.files {
  padding: 40px 0;
}
.files ul li a {
  text-transform: uppercase;
  font-size: 12px;
  display: inline-block;
  padding: 5px 0;
}
.files ul li a:hover{
  text-decoration: underline;
}
.uploader input {
  display: none;
}
.uploader label {
  cursor: pointer;
  text-align: center;
  border: 2px solid #525f7f;
  border-radius: 10px;
  padding: 10px 0;
  opacity: 0.8;
}
.uploader label:hover {
  opacity: 1;
}
.uploader i {
  width: 100%;
  font-size: 42px;
}
.uploader span {
  font-size: 14px;
  text-transform: uppercase;
}
.uploader-list {
  margin: 20px 0 0 0;
}
</style>
